<script>
    import Icon from 'views/components/icon/Icon.svelte'

    export let question
    export let link
    export let isInline = false
    export let hasNoMargin = false
</script>

<a
    class="faq"
    class:is-inline={isInline}
    class:has-no-margin={hasNoMargin}
    href={link}
    target="_blank"
    rel="noopener noreferrer">
    <Icon name="help-circle"></Icon>
    {question}
</a>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.faq {
  display: flex;
  align-items: center;
  background: rgba(17.6%, 48.4%, 70.4%, 0.1);
  color: hsl(205, 60%, 44%);
  border: 1px solid rgba(17.6%, 48.4%, 70.4%, 0.1);
  margin: 16px 0;
  padding: 10px 16px;
  font-size: 14px;
  border-radius: 12px;
  text-decoration: none;
  cursor: pointer;
}
.faq:hover {
  text-decoration: underline;
}
.faq :global(svg) {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  flex-shrink: 0;
}
.faq.is-inline {
  margin: unset;
  padding: unset;
  border: unset;
  background: unset;
  display: inline-flex;
}
.faq.has-no-margin {
  margin: unset;
}</style>
